import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import locationApi from '../../../api/services/LocationApi'
import {
  fetchStatusIs,
  LocationConfig,
  RequestStatus,
} from '../../../api/types'
import AppSpinner from '../../../components/AppSpinner'
import MainLayout from '../../../shared/layout/main-layout/MainLayout'
import AppContext from '../../context'
import {
  setGoals,
  setLocationConfig,
  setSelectedOrganization,
} from '../../context/actions'
import NavbarContext from '../../navbar/context'
import {
  setBackPathname,
  setClosePathname,
  setIsBackButtonVisible,
  setIsCloseButtonVisible,
} from '../../navbar/context/action'
import GoalsView from './GoalsView'

export type GoalsParamsType = {
  locationCode: string
  organizationId: string
}

const Goals = () => {
  const { state, contextDispatch } = useContext(AppContext)
  const { contextDispatch: navbarContextDispatch } = useContext(NavbarContext)

  const navigate = useNavigate()

  const { locationCode, organizationId } = useParams<GoalsParamsType>()

  const [requestStatus, setRequestStatus] = useState<RequestStatus>(
    RequestStatus.Idle
  )
  const { idle, pending, fulfilled } = fetchStatusIs(requestStatus)

  useEffect(() => {
    setBackPathname(navbarContextDispatch, `/${locationCode}`)
    setClosePathname(navbarContextDispatch, `/${locationCode}`)
  }, [locationCode, navbarContextDispatch, state.organizations.length])

  const fetch = useCallback(async () => {
    if (!locationCode || !organizationId) return

    setRequestStatus(RequestStatus.Pending)
    const result = await locationApi.getGoals(locationCode, organizationId)

    if (result && result.success) {
      if (result.data.goals.length === 0) {
        navigate('/blad')
      }
      setGoals(contextDispatch, result.data.goals)
      setIsBackButtonVisible(
        navbarContextDispatch,
        result.data.isOnlyOrganization ? false : true
      )
      setIsCloseButtonVisible(
        navbarContextDispatch,
        result.data.isOnlyOrganization ? false : true
      )
      const data: LocationConfig = {
        backgroundId: result.data.backgroundId,
        logoId: result.data.logoId,
        locationCode: locationCode,
      }
      setLocationConfig(contextDispatch, data)

      if (!state.selectedOrganization) {
        setSelectedOrganization(contextDispatch, result.data.organization)
      }
      setRequestStatus(RequestStatus.Fulfilled)
    } else {
      setRequestStatus(RequestStatus.Rejected)
      navigate('/blad')
    }
  }, [
    contextDispatch,
    locationCode,
    navigate,
    organizationId,
    state.selectedOrganization,
  ])

  useEffect(() => {
    if (idle) fetch()
  }, [fetch, idle])

  return (
    <>
      <MainLayout withNavbar>
        <AppSpinner show={pending} />
        {fulfilled && <GoalsView />}
      </MainLayout>
    </>
  )
}

export default Goals
